// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({ routes: [] }) // base vacía

export const appRoutes = [
  {
    path: '/',
    name: 'HomeSales',
    component: () => import('../components/sales/table.vue')
  },
  { path: '/collections/status-report', name:'CollectionStatusReport', component: () => import('../components/reports/collections/status/container.vue') },
  { path: '/collections/past-due', name: 'PastDueBalancesReport', component: () => import('../components/reports/collections/pastDue.vue') },
  { path: '/balances', name: 'PastDueBalances', component: () => import('../components/expired_sales/table.vue') },
  { path: '/sales-to-authorize', name: 'SalesToAuthorize', component: () => import('../components/auth_sales/table.vue') },
  { path: '/bank_movements', name: 'BankMovements', component: () => import('../components/bank_movements/table.vue') },
  { path: '/influencers', name: 'Influencers', component: () => import('../components/influencers/container.vue') },
  { path: '/contracts', name: 'Contracts', component: () => import('../components/contracts/table.vue') },
  { path: '/expenses', name: 'Expenses', component: () => import('../components/expenses/table.vue') },
  { path: '/influencers-payments', name: 'InfluencersPayments', component: () => import('../components/influencers_payments/table.vue') },
  { path: '/influencers/influencer/:influencer_id', name: 'InfluencerDetail', component: () => import('../components/influencers/influencerDetail.vue') },
  { path: '/sales/total-report', name: 'SalesReportByMonth', component: () => import('../components/reports/sales/salesByMonth.vue') },
  { path: '/sales/influencers-reports', name: 'SalesReportByInfluencers', component: () => import('../components/reports/sales/salesByInfluencers.vue') },
  { path: '/sales/agencies-reports', name: 'SalesReportByAgencies', component: () => import('../components/reports/sales/salesByAgencies.vue') },
  { path: '/sales/department-reports', name: 'SalesReportByDepartment', component: () => import('../components/reports/sales/salesBKvsMGMT.vue') },
  { path: '/sales/users-reports', name: 'SalesReportByUser', component: () => import('../components/reports/sales/salesByUser.vue') },
  { path: '/registers/total-report', name: 'RegistersReportByMonth', component: () => import('../components/reports/registers/salesByMonth.vue') },
  { path: '/registers/expired-sales-report', name: 'ExpiredSalesReport', component: () => import('../components/reports/registers/expiredSalesByMonth.vue') },
  { path: '/registers/influencers-reports', name: 'RegistersByInfluencers', component: () => import('../components/reports/registers/salesByInfluencers.vue') },
  { path: '/registers/agencies-reports', name: 'RegistersByAgencies', component: () => import('../components/reports/registers/salesByAgencies.vue') },
  { path: '/registers/department-reports', name: 'RegistersByDepartment', component: () => import('../components/reports/registers/salesBKvsMGMT.vue') },
  { path: '/registers/users-reports', name: 'RegistersByUser', component: () => import('../components/reports/registers/salesByUser.vue') },
  { path: '/collections/total-report', name: 'CollectionsReportByMonth', component: () => import('../components/reports/collections/salesByMonth.vue') },
  { path: '/collections/influencers-reports', name: 'CollectionsByInfluencers', component: () => import('../components/reports/collections/salesByInfluencers.vue') },
  { path: '/collections/agencies-reports', name: 'CollectionsByAgencies', component: () => import('../components/reports/collections/salesByAgencies.vue') },
  { path: '/collections/department-reports', name: 'CollectionsByDepartment', component: () => import('../components/reports/collections/salesBKvsMGMT.vue') },
  { path: '/collections/users-reports', name: 'CollectionsByUser', component: () => import('../components/reports/collections/salesByUser.vue') },
  { path: '/quotations', name: 'Quotations', component: () => import('../components/quotations/table.vue') },
  { path: '/sales', name: 'SalesList', component: () => import('../components/sales/table.vue') },
  { path: '/sales/:sale_id', name: 'SalesDetail', component: () => import('../components/sales/table.vue') },
  { path: '/canceled', name: 'Canceled', component: () => import('../components/canceled/table.vue') },
  { path: '/settings', name: 'Settings', component: () => import('../components/settings/container.vue') },
  { path: '/clients', name: 'Clients', component: () => import('../components/clients/table.vue') },
  { path: '/verify-agencies', name: 'VerifyAgencies', component: () => import('../components/clients/companies/agencies/verify.vue') },
  { path: '/activity-log', name: 'ActivityLog', component: () => import('../components/activitylog/container.vue') },
  { path: '/clients/agency/:agency_id', name: 'AgencyDetailByAgencyId', component: () => import('../components/clients/companies/agencies/detail.vue') },
  { path: '/clients/brand/:brand_id', name: 'BrandDetailByBrandId', component: () => import('../components/clients/companies/brands/detail.vue') },
  { path: '/clients/agency/:id', name: 'AgencyDetail', component: () => import('../components/clients/companies/agencies/detail.vue') },
  { path: '/clients/brand/:id', name: 'BrandDetail', component: () => import('../components/clients/companies/brands/detail.vue') },
  { path: '/notes', name: 'Notes', component: () => import('../components/notes/container.vue') },
  { path: '/adjustments', name: 'Adjustments', component: () => import('../components/adjustments.vue') },
  { path: '/announcements', name: 'Announcements', component: () => import('../components/announcements/calendar.vue') },
  { path: '/documents', name: 'Documents', component: () => import('../components/documents/container.vue') },
  { path: '/incobrables', name: 'Incobrables', component: () => import('../components/incobrables/table.vue') },
  { path: '/roster-admin', name: 'Roster Admin', component: () => import('../components/influencers/roster/container.vue') },
  { path: '/seguimientos', name: 'Seguimientos', component: () => import('../components/seguimientos/container.vue') },
]

// ---- rutas para Agencia
export const agencyRoutes = [
  { path: '/', name: 'AgencySales', component: () => import('../components/Agencies/sales/container.vue') },
  { path: '/brands', name: 'AgencyBrands', component: () => import('../components/Agencies/brands/container.vue') },
  { path: '/contacts', name: 'AgencyContacts', component: () => import('../components/Agencies/contacts/container.vue') },
]

export const publicRoutes = [
  { path: '/roster', name: 'Roster', component: () => import('../components/Roster/Container.vue') },
]

const getRole = () => store.state.currentUser?.user?.role || null
function waitForUserRole(timeoutMs = 3000) {
  return new Promise(resolve => {
    const now = getRole()
    if (now) return resolve(now)
    const unwatch = store.watch(
      s => s.currentUser?.user?.role,
      role => { unwatch(); resolve(role) }
    )
    setTimeout(() => { try { unwatch() } catch(e) {} ; resolve(getRole()) }, timeoutMs)
  })
}

// inyecta rutas cuando esté el rol
waitForUserRole(3000).then(role => {
  const chosen = role === 'Agencia' ? agencyRoutes : appRoutes
  // Vue Router 3.5+: addRoute (uno por uno)
  if (router.addRoute) {
    chosen.forEach(r => router.addRoute(r))
  } else if (router.addRoutes) { // versiones anteriores
    router.addRoutes(chosen)
  } else {
    // fallback: reset matcher
    const newRouter = new VueRouter({ routes: chosen })
    router.matcher = newRouter.matcher
  }
  if (router.currentRoute.path === '/') {
    // empuja a la home adecuada (opcional)
    router.replace('/')
  }
})

export default router
